import React, { Dispatch, SetStateAction } from 'react';
import FormLabel from 'components/form-label';
import { Input } from 'components/ui/input';

interface IProps {
  disabled: boolean;
  inModal: boolean;
  setDeviceConfig?: Dispatch<SetStateAction<Record<string, string | undefined | null>>>;
  deviceConfig: Record<string, string | undefined | null>;
}
const SimpleDeviceConfig = ({
  disabled,
  inModal = false,
  setDeviceConfig,
  deviceConfig,
}: IProps) => {
  return (
    <div className={!inModal ? 'ml-4 pt-2' : ''}>
      <div className="mb-3">
        <FormLabel
          element="register_id"
          label="Register Id"
          className="text-sm font-medium text-gray-blue-80 mb-1"
        />
        <Input
          name="register_id"
          id="register_id"
          className={inModal ? 'w-full mt-1 bg-gray-blue-1' : 'w-80 mt-1 bg-gray-blue-1'}
          disabled={disabled}
          defaultValue={deviceConfig.registerId || ''}
          onChange={(e) => {
            if (inModal && setDeviceConfig) {
              const { value } = e.currentTarget;
              setDeviceConfig((prev) => ({ ...prev, registerId: value }));
            }
          }}
        />
      </div>
    </div>
  );
};

export default SimpleDeviceConfig;
